var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "popup_wrap country_guide_pop",
      staticStyle: { width: "560px" },
    },
    [
      _c(
        "button",
        {
          staticClass: "layer_close",
          attrs: { type: "button" },
          on: { click: _vm.closePop },
        },
        [_vm._v(" close ")]
      ),
      _c(
        "div",
        { staticClass: "flag_deco", attrs: { "aria-hidden": "true" } },
        _vm._l(_vm.boostedFlagDecos, function (deco, i) {
          return _c("country-flag", {
            key: i,
            staticClass: "flag_item",
            style: deco,
            attrs: { country: _vm.parentInfo.country },
          })
        }),
        1
      ),
      _c(
        "div",
        { staticClass: "popup_cont" },
        [
          _c("h1", { staticClass: "page_title" }, [
            _vm._v(
              _vm._s(
                _vm.$t(_vm.parentInfo.msg.title, { country: _vm.countryName })
              )
            ),
          ]),
          _c("i18n", {
            staticClass: "guide_desc pre_line",
            attrs: { path: _vm.parentInfo.msg.cont, tag: "p" },
            scopedSlots: _vm._u([
              {
                key: "country",
                fn: function () {
                  return [_vm._v(_vm._s(_vm.countryName))]
                },
                proxy: true,
              },
              {
                key: "cnUrl",
                fn: function () {
                  return [
                    _c("a", { attrs: { href: _vm.parentInfo.url } }, [
                      _vm._v(_vm._s(_vm.displayUrl)),
                    ]),
                  ]
                },
                proxy: true,
              },
              {
                key: "comUrl",
                fn: function () {
                  return [
                    _c("a", { attrs: { href: _vm.INTL_SITE_URL } }, [
                      _vm._v(_vm._s(_vm.displayIntlUrl)),
                    ]),
                  ]
                },
                proxy: true,
              },
              {
                key: "important",
                fn: function () {
                  return [_c("b", [_vm._v(_vm._s(_vm.noticeLabel))])]
                },
                proxy: true,
              },
            ]),
          }),
          _c("div", { staticClass: "btn_area text_center" }, [
            _c(
              "a",
              {
                staticClass: "button blue lg",
                attrs: { href: "#" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.goCountrySite()
                  },
                },
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.$t(_vm.parentInfo.msg.btn, { country: _vm.countryName })
                  )
                ),
              ]
            ),
          ]),
          _c("p", { staticClass: "no_show_check" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.noShow,
                  expression: "noShow",
                },
              ],
              attrs: { type: "checkbox", id: "country_guide_no_show" },
              domProps: {
                checked: Array.isArray(_vm.noShow)
                  ? _vm._i(_vm.noShow, null) > -1
                  : _vm.noShow,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.noShow,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.noShow = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.noShow = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.noShow = $$c
                  }
                },
              },
            }),
            _c("label", { attrs: { for: "country_guide_no_show" } }, [
              _vm._v(
                _vm._s(
                  _vm.$t("msg.MAIN010G030.044", {
                    days: _vm.parentInfo.noShowDays,
                  })
                )
              ),
            ]),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }